// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"85ea9986","449":"85c6aff4","488":"fd0e17fb","536":"57af16c9","570":"74063f53","699":"c53aff80","724":"d4d7df3d","818":"6e5aec5b","871":"d5f91882"}[chunkId] + ".chunk.js";
};